import React from 'react';
import Marquee from "react-fast-marquee";
import './SlidingAnimation.css';

const SlidingAnimation = () => {
    return (

        <div className='max-w-7xl mx-auto px-6 mt-20'>

            <div className='text-center mb-20'>
                <h3 className="text-xs md:text-sm xl:text-md font-semibold  tracking-widest mb-4 text-[#ff014f] uppercase">Technology</h3>
                <h1 className='text-3xl md:text-4xl xl:text-7xl font-bold'>Which Technology I'm Expert</h1>
            </div>

            <div className='mx-5 grid'>
                <Marquee direction="left" speed={100}>
                    <div className="mx-5">
                        <img className='md:w-32 w-16' src="https://i.ibb.co/syZPRx1/5847f5bdcef1014c0b5e489c-removebg-preview.png" alt="" />
                    </div>
                    <div className="mx-5">
                        <img className='md:w-20 w-10' src="https://i.ibb.co/PDmVK5V/html5-logo-opencode-css-8-removebg-preview.png" alt="" />
                    </div>
                    <div className="mx-5">
                        <img className='md:w-24 w-14' src="https://i.ibb.co/PYLYqJJ/bootstrap-removebg-preview.png" alt="" />
                    </div>
                    <div className="mx-5">
                        <img className='md:w-60 w-40' src="https://i.ibb.co/C836LF9/tailwind.png" alt="" />
                    </div>
                    <div className="mx-5">
                        <img className='md:w-20 w-10' src="https://i.ibb.co/Lk0kXzD/kisspng-javascript-html-computer-software-web-browser-watermark-5acdbd54ac19f7-448498321523432788704.png" alt="" />
                    </div>
                    <div className="mx-5">
                        <img className='md:w-20 w-12' src="https://i.ibb.co/PhthKH6/Typescript-logo-2020-svg-removebg-preview.png" alt="" />
                    </div>
                    <div className="mx-5">
                        <img className='md:w-40 w-28' src="https://i.ibb.co/v3TWpGD/j-Query-removebg-preview.png" alt="" />
                    </div>
                    <div className="mx-5">
                        <img className='md:w-20 w-14' src="https://i.ibb.co/3MG6sQk/download.png" alt="" />
                    </div>
                    <div className="mx-5">
                        <img className='md:w-32 w-20' src="https://i.ibb.co/3vqS9qs/112723-development-512x512.png" alt="" />
                    </div>
                    <div className="mx-5">
                        <img className='md:w-20 w-14' src="https://i.ibb.co/r4ST5RY/expressjs-removebg-preview.png" alt="" />
                    </div>
                    <div className="mx-5">
                        <img className='md:w-48 w-28' src="https://i.ibb.co/591vg9k/MDB-BIG-D-96d632a9.png" alt="" />
                    </div>
                    <div className="mx-5">
                        <img className='md:w-40 w-24' src="https://i.ibb.co/VM7DqtL/Git-Hub-Logo-removebg-preview.png" alt="" />
                    </div>

                    <div className="mx-5">
                        <img className='md:w-20 w-10' src="https://i.ibb.co/1nBs4D7/Rlogical-Blog-Images-thumbnail-removebg-preview.png" alt="" />
                    </div>
                    <div className="mx-5">
                        <img className='md:w-20 w-10' src="https://i.ibb.co/T0PHDxh/Wordpress-Blue-logo-removebg-preview.png" alt="" />
                    </div>
                    <div className="mx-5">
                        <img className='md:w-48 w-32' src="https://i.ibb.co/pQcMMBF/shopify-logo-white-300x150.png" alt="" />
                    </div>
                </Marquee>
            </div>

            <div className="divider mt-20"></div>
        </div>
    );
};

export default SlidingAnimation;